const authActionConstants = {
  GET_CURRENT_USER_LOADING_ON: 'GET_CURRENT_USER_LOADING_ON',
  GET_CURRENT_USER_LOADING_OFF: 'GET_CURRENT_USER_LOADING_OFF',
  GET_CURRENT_USER: 'GET_CURRENT_USER',
  SET_ANY_ORG_ADMIN: 'SET_ANY_ORG_ADMIN',

  CONFIRM_NUMBER: 'CONFIRM_NUMBER',
  CONFIRM_NUMBER_SUCCESS: 'CONFIRM_NUMBER_SUCCESS',
  CONFIRM_NUMBER_ERROR: 'CONFIRM_NUMBER_ERROR',

  GET_NUMBER_CONFIRMATION: 'GET_NUMBER_CONFIRMATION',
  GET_NUMBER_CONFIRMATION_SUCCESS: 'GET_NUMBER_CONFIRMATION_SUCCESS',
  GET_NUMBER_CONFIRMATION_ERROR: 'GET_NUMBER_CONFIRMATION_ERROR',

  UPDATE_USER_LOCATION_SUCCESS: 'UPDATE_USER_LOCATION_SUCCESS',

  RESEND_CONFIRMATION_CODE: 'RESEND_CONFIRMATION_CODE',
  RESEND_CONFIRMATION_CODE_SUCCESS: 'RESEND_CONFIRMATION_CODE_SUCCESS',
  RESEND_CONFIRMATION_CODE_ERROR: 'RESEND_CONFIRMATION_CODE_ERROR',
  CLEAR_PHONE_CONFIRMATION_DATA: 'CLEAR_PHONE_CONFIRMATION_DATA',

  CREATE_ORGANIZATION_ACCESS_REQUEST: 'CREATE_ORGANIZATION_ACCESS_REQUEST',
  CREATE_ORGANIZATION_ACCESS_REQUEST_SUCCESS: 'CREATE_ORGANIZATION_ACCESS_REQUEST_SUCCESS',
  CREATE_ORGANIZATION_ACCESS_REQUEST_ERROR: 'CREATE_ORGANIZATION_ACCESS_REQUEST_ERROR',
};

export default authActionConstants;
